// src/design-system/PathStepper.tsx
export type PathStep = { label: string; sub?: string; color: string; hollow?: boolean; n?: string };

/** مسار أفقي بكرات مضيئة متصلة بخطوط متدرجة (حالة الدفعات / مراحل الصرف / أمر الشراء). */
export function PathStepper({ steps, subMono = true }: { steps: PathStep[]; subMono?: boolean }) {
  return (
    <ol className="m-0 flex list-none items-start p-0" aria-label="مسار الحالة">
      {steps.map((s, i) => {
        const prev = steps[i - 1];
        return (
          <li key={`${s.label}-${i}`} className="relative flex flex-1 flex-col items-center gap-2 text-center">
            {prev && (
              <span aria-hidden className="absolute top-[11px] h-0.5 w-full"
                style={{ insetInlineEnd: "50%", background: `linear-gradient(90deg,${s.color},${prev.color})`, boxShadow: "0 0 9px rgba(214,172,85,.35)" }} />
            )}
            <span className="mono relative grid h-[22px] w-[22px] place-items-center rounded-full text-[11px]"
              style={{
                background: s.hollow ? "rgba(148,180,214,.10)" : `radial-gradient(circle at 35% 30%,${s.color},rgba(9,24,39,.9))`,
                boxShadow: s.hollow ? "0 0 0 1px rgba(148,180,214,.25)" : `0 0 15px ${s.color}, 0 0 0 1px ${s.color}`,
                color: s.hollow ? "#8FA3B8" : "#F5E4C0",
              }}>{s.n}</span>
            {s.sub && <span className={`text-[11.5px] text-muted ${subMono ? "mono" : ""}`}>{s.sub}</span>}
            <span className="text-xs" style={{ color: s.color }}>{s.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
